import { FunctionComponent, useContext, useEffect, useState } from "react";
import styles from "./DashboardSideBar.module.css";
import images from "../../../assets/images/index";
import { useLocation, useNavigate } from "react-router-dom";
import { globalContext } from "../../../Provider/AppProvider";
import { roles } from "../../../helper";
import AddIcon from "../../../assets/images/AddIcon.svg";
import organalytics from "../../../assets/images/organalytics.svg";
import v2pricing from "../../../assets/images/v2pricing.svg";
import salesrep from "../../../assets/images/salesrep.svg";
import affiliate from "../../../assets/images/affiliate.svg";
import eventupdate from "../../../assets/images/eventupdate.svg";
import teamupdate from "../../../assets/images/teamsupdate.svg";
// import teamsupdate from "../../../assets/images/teamupdate.svg";
import venueupdate from "../../../assets/images/venue.svg";
import ticketmaster from "../../../assets/images/ticketmaster.svg";
import trends from "../../../assets/images/trends.svg";
import goals from "../../../assets/images/goals.svg";
import dashboard from "../../../assets/images/Dashboard.svg";
import users from "../../../assets/images/Users.svg";
import tickets from "../../../assets/images/tickets.svg";
import supportTickets from "../../../assets/images/support-tickets.svg";
import appversion from "../../../assets/images/teamsupdate.svg";
import { isPageAccessControlledRole } from "../../../constants/pageAccess";
import {
  Bell,
  BadgeCheck,
  DollarSign,
  LayoutDashboard,
  Mail,
  MessageSquare,
  PieChart,
  RefreshCcw,
  ShoppingCart,
  Tag,
  Target,
  Ticket,
  Users,
  XCircle,
  Database,
} from "lucide-react";

interface SidebarProps {
  path: string;
  onclick: () => void;
  label: string;
  icon: string;
  alt: string;
  badge?: string;
  buyIcon?: FunctionComponent<{ className?: string }>;
}

interface Dashboardprops {
  showSidebar?: boolean;
}

const DashboardSideBar: FunctionComponent<Dashboardprops> = ({
  showSidebar,
}) => {
  const location = useLocation();
  const isBuyPath = location.pathname.startsWith("/buy-");
  const isSharedAffiliatePath = location.pathname === "/affiliate" || location.pathname.startsWith("/affiliate/");
  const [sidebarMode, setSidebarMode] = useState<"sell" | "buy">(() =>
    isBuyPath || (isSharedAffiliatePath && sessionStorage.getItem("qa-admin-sidebar-mode") === "buy")
      ? "buy"
      : "sell",
  );
  const {
    sidebarQuickAsystLogo,
    dahsboardIcon,
    sidebarTicketIcon,
    sidebarUserIcon,
    QuickAsystIcon,
    errordashboard,
    barcodeIcon,
    manageAccountIcon,
    settings,
    notificationIcon
  } = images;
  const navigate = useNavigate();
  const {globalState} = useContext<any>(globalContext)
  /** Support tickets with unread Victory Live replies (kept current by useVlSupportAlerts). */
  const supportUnreadCount = Number(globalState?.vlSupportUnread || 0);
  const supportUnreadBadge = supportUnreadCount > 0 ? String(supportUnreadCount) : undefined;
  
  const routes: SidebarProps[] = [];
  const buyRoutes: SidebarProps[] = [
    {
      path: "buy-dashboard",
      onclick: () => navigate("/buy-dashboard"),
      label: "Dashboard",
      icon: dashboard,
      alt: "BuyDashboardIcon",
      buyIcon: LayoutDashboard,
    },
    {
      path: "buy-orders",
      onclick: () => navigate("/buy-orders"),
      label: "Orders",
      icon: sidebarTicketIcon,
      alt: "BuyOrdersIcon",
      buyIcon: Ticket,
    },
    {
      path: "buy-user-admin-management",
      onclick: () => navigate("/buy-user-admin-management"),
      label: "Members",
      icon: users,
      alt: "BuyUserAdminIcon",
      buyIcon: Users,
    },
    {
      path: "affiliate",
      onclick: () => navigate("/affiliate"),
      label: "Affiliates",
      icon: affiliate,
      alt: "BuyAffiliatesIcon",
      buyIcon: BadgeCheck,
    },
    {
      path: "buy-fulfillment",
      onclick: () => navigate("/buy-fulfillment"),
      label: "Fulfillment",
      icon: sidebarTicketIcon,
      alt: "BuyFulfillmentIcon",
      buyIcon: ShoppingCart,
    },
    {
      path: "buy-analytics",
      onclick: () => navigate("/buy-analytics"),
      label: "Buy Analytics",
      icon: organalytics,
      alt: "BuyAnalyticsIcon",
      buyIcon: PieChart,
    },
    {
      path: "buy-pricing-intelligence",
      onclick: () => navigate("/buy-pricing-intelligence"),
      label: "Pricing Intelligence",
      icon: goals,
      alt: "BuyPricingIntelligenceIcon",
      buyIcon: Target,
    },
    {
      path: "buy-revenue-reports",
      onclick: () => navigate("/buy-revenue-reports"),
      label: "Revenue Reports",
      icon: organalytics,
      alt: "BuyRevenueReportsIcon",
      buyIcon: DollarSign,
    },
    {
      path: "buy-all-purchases",
      onclick: () => navigate("/buy-all-purchases"),
      label: "All Purchases",
      icon: sidebarTicketIcon,
      alt: "BuyOrdersIcon",
      buyIcon: Ticket,
    },
    {
      path: "buy-failed-purchases",
      onclick: () => navigate("/buy-failed-purchases"),
      label: "Failed Purchases",
      icon: errordashboard,
      alt: "BuyFailedPurchasesIcon",
      buyIcon: XCircle,
    },
    {
      path: "buy-renewal-failures",
      onclick: () => navigate("/buy-renewal-failures"),
      label: "Renewal Failures",
      icon: errordashboard,
      alt: "BuyRenewalFailuresIcon",
      buyIcon: RefreshCcw,
    },
    {
      path: "buy-email-templates",
      onclick: () => navigate("/buy-email-templates"),
      label: "Email Templates",
      icon: notificationIcon,
      alt: "BuyEmailTemplatesIcon",
      buyIcon: Mail,
    },
    {
      path: "buy-email-notifications",
      onclick: () => navigate("/buy-email-notifications"),
      label: "Email Notifications",
      icon: notificationIcon,
      alt: "BuyEmailNotificationsIcon",
      buyIcon: MessageSquare,
    },
    // {
    //   path: "buy-alerts",
    //   onclick: () => navigate(""),
    //   label: "Alerts",
    //   icon: notificationIcon,
    //   alt: "BuyAlertsIcon",
    //   buyIcon: Bell,
    // },
    {
      path: "buy-events-markup",
      onclick: () => navigate("/buy-events-markup"),
      label: "Events-Markup",
      icon: goals,
      alt: "BuyPricingIntelligenceIcon",
      buyIcon: Target,
    },
    {
      path: "buy-ticket-savings",
      onclick: () => navigate("/buy-ticket-savings"),
      label: "Ticket Savings",
      icon: goals,
      alt: "BuyTicketSavingsIcon",
      buyIcon: DollarSign,
    },
    {
      path: "buy-master-data",
      onclick: () => navigate("/buy-master-data"),
      label: "Master Data",
      icon: goals,
      alt: "BuyMasterDataIcon",
      buyIcon: Database,
    },
  ];
  
  if (globalState.profile.userRole === roles.ADMIN) {
    routes.push(
      {
        path: "dashboard",
        onclick: () => navigate("/dashboard"),
        label: "Dashboard",
        icon: dashboard,
        alt: "DashboardIcon",
      },
      {
        path: "managetickets",
        onclick: () => navigate("/managetickets"),
        label: "Manage Tickets",
        icon: tickets,
        alt: "TicketsIcon",
      },
      {
        path: "support-tickets",
        onclick: () => navigate("/support-tickets"),
        label: "Support Tickets",
        icon: supportTickets,
        alt: "SupportTicketsIcon",
        badge: supportUnreadBadge,
      },
      {
        path: "barcodes",
        onclick: () => navigate("/barcodes"),
        label: "Barcodes",
        icon: barcodeIcon,
        alt: "BarcodesIcon",
      },
      {
        path: "addticket",
        onclick: () => navigate("/addticket"),
        label: "Add Tickets",
        icon: AddIcon,
        alt: "AddTicketsIcon",
      },
      {
        path: "users",
        onclick: () => navigate("/users"),
        label: "Users",
        icon: users,
        alt: "UsersIcon",
      },
      {
        path: "trends",
        onclick: () => navigate("/trends"),
        label: "Trends",
        icon: trends,
        alt: "TrendsIcon",
      },
      {
        path: "analytics",
        onclick: () => navigate("/analytics"),
        label: "Org Analytics",
        icon: organalytics,
        alt: "OrgAnalyticsIcon",
      },
      {
        path: "goals",
        onclick: () => navigate("/goals"),
        label: "Goals",
        icon: goals,
        alt: "GoalsIcon",
      },
      {
        path: "salesrep",
        onclick: () => navigate("/salesrep"),
        label: "Sales Reps",
        icon: salesrep,
        alt: "SalesRepsIcon",
      },
      {
        path: "affiliate",
        onclick: () => navigate("/affiliate"),
        label: "Affiliates",
        icon: affiliate,
        alt: "AffiliateIcon",
      },
      {
        path: "event-update",
        onclick: () => navigate("/event-update"),
        label: "Events Update",
        icon: eventupdate,
        alt: "EventsUpdateIcon",
      },
      {
        path: "teamupdate",
        onclick: () => navigate("/teamupdate"),
        label: "Teams Update",
        icon: teamupdate,
        alt: "teamUpdateIcon",
      },
      {
        path: "venueupdate",
        onclick: () => navigate("/venueupdate"),
        label: "Venue Update",
        icon: venueupdate,
        alt: "venueUpdateIcon",
      },
      {
        path: "ticketmaster",
        onclick: () => navigate("/ticketmaster"),
        label: "Ticketmaster Catalog",
        icon: ticketmaster,
        alt: "TicketmasterIcon",
       },
{
          path: "app-update",
          onclick: () => navigate("/app-update"),
          label: "App Update",
          icon: appversion,
          alt: "AppVersionIcon",
        },
       {
         path: "setting",
         onclick: () => navigate("/setting"),
         label: "Settings",
         icon: settings,
         alt: "settingsIcon",
       },
       {
         path: "auditLogs",
         onclick: () => navigate("/auditLogs"),
         label: "Audit Logs",
         icon: errordashboard,
         alt: "activityLogsIcon",
       },
       {
         path: "price-change-logs",
         onclick: () => navigate("/price-change-logs"),
         label: "Price Change Logs",
         icon: errordashboard,
         alt: "priceChangeLogsIcon",
       },
       {
         path: "sync-verification-logs",
         onclick: () => navigate("/sync-verification-logs"),
         label: "Sync Verification Logs",
         icon: errordashboard,
         alt: "syncVerificationLogsIcon",
       },
       {
         path: "role-page-access",
         onclick: () => navigate("/role-page-access"),
         label: "Role Access",
         icon: manageAccountIcon,
         alt: "roleAccessIcon",
      }
    )
  } else if (globalState.profile.userRole === roles.AFFILIATER_ADMIN) {
    routes.push(
      {
        path: "dashboard",
        onclick: () => navigate("/dashboard"),
        label: "Dashboard",
        icon: dahsboardIcon,
        alt: "DashboardIcon",
      },
      {
        path: "managetickets",
        onclick: () => navigate("/managetickets"),
        label: "Manage Tickets",
        icon: tickets,
        alt: "TicketsIcon",
      },
      {
        path: "support-tickets",
        onclick: () => navigate("/support-tickets"),
        label: "Support Tickets",
        icon: supportTickets,
        alt: "SupportTicketsIcon",
        badge: supportUnreadBadge,
      },
      {
        path: "barcodes",
        onclick: () => navigate("/barcodes"),
        label: "Barcodes",
        icon: barcodeIcon,
        alt: "BarcodesIcon",
      },
      {
        path: "addticket",
        onclick: () => navigate("/addticket"),
        label: "Add Tickets",
        icon: AddIcon,
        alt: "AddTicketsIcon",
      },
      {
        path: "users",
        onclick: () => navigate("/users"),
        label: "Users",
        icon: users,
        alt: "UsersIcon",
      },
      {
        path: "trends",
        onclick: () => navigate("/trends"),
        label: "Trends",
        icon: trends,
        alt: "TrendsIcon",
      },
      {
        path: "analytics",
        onclick: () => navigate("/analytics"),
        label: "Org Analytics",
        icon: organalytics,
        alt: "OrgAnalyticsIcon",
      },
      {
        path: "goals",
        onclick: () => navigate("/goals"),
        label: "Goals",
        icon: goals,
        alt: "GoalsIcon",
      },
      {
        path: "salesrep",
        onclick: () => navigate("/salesrep"),
        label: "Sales Reps",
        icon: salesrep,
        alt: "SalesRepsIcon",
      },
      {
        path: "affiliate",
        onclick: () => navigate("/affiliate"),
        label: "Affiliates",
        icon: affiliate,
        alt: "AffiliateIcon",
      },
      {
        path: "event-update",
        onclick: () => navigate("/event-update"),
        label: "Events Update",
        icon: eventupdate,
        alt: "EventsUpdateIcon",
      },
      {
        path: "teamupdate",
        onclick: () => navigate("/teamupdate"),
        label: "Teams Update",
        icon: teamupdate,
        alt: "teamUpdateIcon",
      },
      {
        path: "venueupdate",
        onclick: () => navigate("/venueupdate"),
        label: "Venue Update",
        icon: venueupdate,
        alt: "venueUpdateIcon",
      },
      {
        path: "ticketmaster",
        onclick: () => navigate("/ticketmaster"),
        label: "Ticketmaster Catalog",
        icon: ticketmaster,
        alt: "TicketmasterIcon",
      },
      {
        path: "setting",
        onclick: () => navigate("/setting"),
        label: "Settings",
        icon: settings,
        alt: "settingsIcon",
      },
    )
  } else if (globalState.profile.userRole === "logitix_user") {
    routes.push(
      {
        path: "tickets",
        onclick: () => navigate("/tickets"),
        label: "Tickets",
        icon: sidebarTicketIcon,
        alt: "TicketsIcon",
      },
      {
        path: "settings",
        onclick: () => navigate("/settings"),
        label: "Settings",
        icon: settings,
        alt: "settingsIcon",
      },
      {
        path: "logs",
        onclick: () => navigate("/logs"),
        label: "Logs",
        icon: errordashboard,
        alt: "errorIcon",
      },
    )
  } else if (globalState.profile.userRole === roles.SUPER_USER) {
    routes.push(
      {
        path: "dashboard",
        onclick: () => navigate("/dashboard"),
        label: "Dashboard",
        icon: dahsboardIcon,
        alt: "DashboardIcon",
      },
      {
        path: "managetickets",
        onclick: () => navigate("/managetickets"),
        label: "Manage Tickets",
        icon: sidebarTicketIcon,
        alt: "ManageTicketsIcon",
      },
      {
        path: "support-tickets",
        onclick: () => navigate("/support-tickets"),
        label: "Support Tickets",
        icon: supportTickets,
        alt: "SupportTicketsIcon",
        badge: supportUnreadBadge,
      },
      {
        path: "profile",
        onclick: () => navigate("/profile"),
        label: "Profile",
        icon: sidebarUserIcon,
        alt: "ProfileIcon",
      },
    );
  } else if (globalState.profile.userRole === "marketing_user") {
    routes.push(
      {
        path: "dashboard",
        onclick: () => navigate("/dashboard"),
        label: "Dashboard",
        icon: dahsboardIcon,
        alt: "DashboardIcon",
      },
      {
        path: "managetickets",
        onclick: () => navigate("/managetickets"),
        label: "Manage Tickets",
        icon: tickets,
        alt: "TicketsIcon",
      },
      {
        path: "support-tickets",
        onclick: () => navigate("/support-tickets"),
        label: "Support Tickets",
        icon: supportTickets,
        alt: "SupportTicketsIcon",
        badge: supportUnreadBadge,
      },
      {
        path: "barcodes",
        onclick: () => navigate("/barcodes"),
        label: "Barcodes",
        icon: barcodeIcon,
        alt: "BarcodesIcon",
      },
      {
        path: "addticket",
        onclick: () => navigate("/addticket"),
        label: "Add Tickets",
        icon: AddIcon,
        alt: "AddTicketsIcon",
      },
      {
        path: "users",
        onclick: () => navigate("/users"),
        label: "Users",
        icon: users,
        alt: "UsersIcon",
      },
      {
        path: "trends",
        onclick: () => navigate("/trends"),
        label: "Trends",
        icon: trends,
        alt: "TrendsIcon",
      },
      {
        path: "analytics",
        onclick: () => navigate("/analytics"),
        label: "Org Analytics",
        icon: organalytics,
        alt: "OrgAnalyticsIcon",
      },
      {
        path: "goals",
        onclick: () => navigate("/goals"),
        label: "Goals",
        icon: goals,
        alt: "GoalsIcon",
      },
      {
        path: "salesrep",
        onclick: () => navigate("/salesrep"),
        label: "Sales Reps",
        icon: salesrep,
        alt: "SalesRepsIcon",
      },
      {
        path: "affiliate",
        onclick: () => navigate("/affiliate"),
        label: "Affiliates",
        icon: affiliate,
        alt: "AffiliateIcon",
      },
      {
        path: "event-update",
        onclick: () => navigate("/event-update"),
        label: "Events Update",
        icon: eventupdate,
        alt: "EventsUpdateIcon",
      },
      {
        path: "teamupdate",
        onclick: () => navigate("/teamupdate"),
        label: "Teams Update",
        icon: teamupdate,
        alt: "teamUpdateIcon",
      },
      {
        path: "venueupdate",
        onclick: () => navigate("/venueupdate"),
        label: "Venue Update",
        icon: venueupdate,
        alt: "venueUpdateIcon",
      },
      {
        path: "ticketmaster",
        onclick: () => navigate("/ticketmaster"),
        label: "Ticketmaster Catalog",
        icon: ticketmaster,
        alt: "TicketmasterIcon",
      },
      {
        path: "setting",
        onclick: () => navigate("/setting"),
        label: "Settings",
        icon: settings,
        alt: "settingsIcon",
      },
      {
        path: "profile",
        onclick: () => navigate("/profile"),
        label: "Profile",
        icon: sidebarUserIcon,
        alt: "ProfileIcon",
      },
    );
  } else if (globalState.profile.userRole === roles.SUB_ADMIN) {
    routes.push(
      {
        path: "dashboard",
        onclick: () => navigate("/dashboard"),
        label: "Dashboard",
        icon: dashboard,
        alt: "DashboardIcon",
      },
      {
        path: "managetickets",
        onclick: () => navigate("/managetickets"),
        label: "Manage Tickets",
        icon: tickets,
        alt: "TicketsIcon",
      },
      {
        path: "support-tickets",
        onclick: () => navigate("/support-tickets"),
        label: "Support Tickets",
        icon: supportTickets,
        alt: "SupportTicketsIcon",
        badge: supportUnreadBadge,
      },
      {
        path: "barcodes",
        onclick: () => navigate("/barcodes"),
        label: "Barcodes",
        icon: barcodeIcon,
        alt: "BarcodesIcon",
      },
      {
        path: "addticket",
        onclick: () => navigate("/addticket"),
        label: "Add Tickets",
        icon: AddIcon,
        alt: "AddTicketsIcon",
      },
      {
        path: "users",
        onclick: () => navigate("/users"),
        label: "Users",
        icon: users,
        alt: "UsersIcon",
      },
      {
        path: "trends",
        onclick: () => navigate("/trends"),
        label: "Trends",
        icon: trends,
        alt: "TrendsIcon",
      },
      {
        path: "analytics",
        onclick: () => navigate("/analytics"),
        label: "Org Analytics",
        icon: organalytics,
        alt: "OrgAnalyticsIcon",
      },
      {
        path: "goals",
        onclick: () => navigate("/goals"),
        label: "Goals",
        icon: goals,
        alt: "GoalsIcon",
      },
      {
        path: "salesrep",
        onclick: () => navigate("/salesrep"),
        label: "Sales Reps",
        icon: salesrep,
        alt: "SalesRepsIcon",
      },
      {
        path: "affiliate",
        onclick: () => navigate("/affiliate"),
        label: "Affiliates",
        icon: affiliate,
        alt: "AffiliateIcon",
      },
      {
        path: "event-update",
        onclick: () => navigate("/event-update"),
        label: "Events Update",
        icon: eventupdate,
        alt: "EventsUpdateIcon",
      },
      {
        path: "teamupdate",
        onclick: () => navigate("/teamupdate"),
        label: "Teams Update",
        icon: teamupdate,
        alt: "teamUpdateIcon",
      },
      {
        path: "venueupdate",
        onclick: () => navigate("/venueupdate"),
        label: "Venue Update",
        icon: venueupdate,
        alt: "venueUpdateIcon",
      },
      {
        path: "ticketmaster",
        onclick: () => navigate("/ticketmaster"),
        label: "Ticketmaster Catalog",
        icon: ticketmaster,
        alt: "TicketmasterIcon",
      },
       {
         path: "app-update",
         onclick: () => navigate("/app-update"),
         label: "App Update",
         icon: appversion,
         alt: "AppVersionIcon",
       },
      {
        path: "setting",
        onclick: () => navigate("/setting"),
        label: "Settings",
        icon: settings,
        alt: "settingsIcon",
      },
      {
        path: "auditLogs",
        onclick: () => navigate("/auditLogs"),
        label: "Audit Logs",
        icon: errordashboard,
        alt: "activityLogsIcon",
      },
       {
         path: "price-change-logs",
         onclick: () => navigate("/price-change-logs"),
         label: "Price Change Logs",
         icon: errordashboard,
         alt: "priceChangeLogsIcon",
       },
       {
         path: "sync-verification-logs",
         onclick: () => navigate("/sync-verification-logs"),
         label: "Sync Verification Logs",
         icon: errordashboard,
         alt: "syncVerificationLogsIcon",
       },
      {
        path: "role-page-access",
        onclick: () => navigate("/role-page-access"),
        label: "Role Access",
        icon: manageAccountIcon,
        alt: "roleAccessIcon",
      }
    );
  }

  const pageKeyBySidebarPath: Record<string, string> = {
    dashboard: "dashboard",
    trends: "trends",
    goals: "goals",
    managetickets: "managetickets",
    "support-tickets": "supporttickets",
    barcodes: "barcodes",
    addticket: "addticket",
    analytics: "analytics",
    salesrep: "salesrep",
    "event-update": "event-update",
    teamupdate: "teamupdate",
    venueupdate: "venueupdate",
    ticketmaster: "ticketmaster",
    setting: "setting",
    appversion: "appversion",
    "new-list": "new-list",
    tickets: "tickets",
    users: "users",
    affiliate: "affiliate",
    logs: "logs",
    auditLogs: "logs",
    "price-change-logs": "logs",
    "sync-verification-logs": "logs",
    profile: "profile",
    "buy-dashboard": "buy-dashboard",
    "buy-orders": "buy-orders",
    "buy-user-admin-management": "buy-user-admin-management",
    "buy-fulfillment": "buy-fulfillment",
    "buy-analytics": "buy-analytics",
    "buy-pricing-intelligence": "buy-pricing-intelligence",
    "buy-revenue-reports": "buy-revenue-reports",
    "buy-all-purchases": "buy-all-purchases",
    "buy-failed-purchases": "buy-failed-purchases",
    "buy-renewal-failures": "buy-renewal-failures",
    "buy-email-templates": "buy-email-templates",
    "buy-email-notifications": "buy-email-notifications",
    "buy-events-markup": "buy-events-markup",
    "buy-ticket-savings": "buy-ticket-savings",
    "buy-master-data": "buy-master-data",
  };

  const role = globalState.profile.userRole;
  const allowedPageKeys: string[] = globalState?.profile?.allowedPageKeys || [];

  useEffect(() => {
    // Affiliates is shared by Buy and Sell, so retain the side used to open it.
    if (isSharedAffiliatePath) return;
    const mode = isBuyPath ? "buy" : "sell";
    setSidebarMode(mode);
    sessionStorage.setItem("qa-admin-sidebar-mode", mode);
  }, [isBuyPath, isSharedAffiliatePath]);

  const handleModeChange = (mode: "buy" | "sell") => {
    setSidebarMode(mode);
    sessionStorage.setItem("qa-admin-sidebar-mode", mode);
    navigate(mode === "buy" ? "/buy-dashboard" : "/dashboard");
  };

  const activeRoutes = sidebarMode === "buy" ? buyRoutes : routes;

  const visibleRoutes = activeRoutes.filter((route) => {
    if (!isPageAccessControlledRole(role)) {
      return true;
    }
    const pageKey = pageKeyBySidebarPath[route.path];
    if (!pageKey) {
      return false;
    }
    return allowedPageKeys.includes(pageKey);
  });

  const pathSlug = location.pathname.slice(1);
  const isRouteActive = (routePath: string) => {
    if (routePath === "managetickets" && (pathSlug === "managetickets" || pathSlug === "new-list")) {
      return true;
    }
    return pathSlug === routePath || pathSlug.includes(routePath);
  };

  return (
    <div
      className={`${styles.dashboardSideBar} ${
        showSidebar ? styles.expanded : styles.collapsed
      }`}
    >
      <div className={`${styles.logo} ${
        showSidebar ? styles.expandedlogo : styles.collapsedlogo
      }`}>
        <img
          className={
            showSidebar? styles.QuickAsystIcon  : styles.QuickAsystIconhide
          }
          alt="sidebarLogo"
          src={showSidebar? sidebarQuickAsystLogo: QuickAsystIcon}
          onClick={() => {
            const userRole = globalState.profile.userRole;
            if (isPageAccessControlledRole(userRole)) {
              const hasDashboardAccess = allowedPageKeys.includes("dashboard");
              navigate(hasDashboardAccess ? "/dashboard" : "/no-access");
              return;
            }
            if (userRole === roles.AFFILIATER_ADMIN) {
              navigate("/dashboard");
              return;
            }
            if (userRole===roles.ADMIN) {
              navigate("/dashboard");
              return;
            }
            if (userRole === roles.SUPER_USER) {
              navigate("/dashboard");
              return;
            }
            navigate("/managetickets");
          }}
          data-testid="sidebarLogo"
        />
      </div>
                        
    {showSidebar && globalState.profile.userRole !== roles.SUPER_USER && globalState.profile.userRole !== roles.AFFILIATER_ADMIN && (
        <div className={styles.toggleContainer}>
          <button 
            className={`${styles.toggleBtn} ${sidebarMode === 'buy' ? styles.buyactive : ''}`}
            onClick={() => handleModeChange('buy')}
          >
            <span className={styles.buyIcon}>
              <ShoppingCart className={styles.modeIcon} />
            </span> Buy
          </button>
          <button 
            className={`${styles.toggleBtn} ${sidebarMode === 'sell' ? styles.sellactive : ''}`}
            onClick={() => handleModeChange('sell')}
          >
            <span className={styles.sellIcon}>
              <Tag className={styles.modeIcon} />
            </span> Sell
          </button>
        </div>
      )}
      
      {showSidebar ? (
        <div className={styles.menuContainer}>
          {/* mapping the sidebar routes  */}
          {visibleRoutes.map((route: SidebarProps, index: number) => (
            <div
              className={
                isRouteActive(route.path)
                  ? styles.dashboardActive
                  : styles.dashboardInactive
              }
              onClick={route.onclick}
              key={`sidebar-${index}`}
            >
              {sidebarMode === "buy" && route.buyIcon ? (
                <route.buyIcon className={styles.buyRouteIcon} />
              ) : (
                <img
                  className={styles.roundedOutlineDashboard}
                  alt={route.alt}
                  src={route.icon}
                />
              )}
              <div className={styles.dashboard1}>
                {route.label}
                {route.badge && <span className={styles.badge}>{route.badge}</span>}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.menuContainer}>
          {/* mapping the sidebar routes  */}
          {visibleRoutes.map((route: SidebarProps, index: number) => (
            <div
              className={
                isRouteActive(route.path)
                  ? styles.dashboardActive
                  : styles.dashboardInactive
              }
              onClick={route.onclick}
              key={`sidebar-${index}`}
            >
              {sidebarMode === "buy" && route.buyIcon ? (
                <route.buyIcon className={styles.buyRouteIcon} />
              ) : (
                <img
                  className={styles.roundedOutlineDashboard}
                  alt={route.alt}
                  src={route.icon}
                />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardSideBar;
